module.exports = __webpack_public_path__ + "img/20-min.0efd6013.jpg";